import {SelectEntityItem} from 'components/SelectEntityItem'
import _ from 'lodash'
import React from 'react'
import {notEmpty} from 'views/Shared'
import {courseSchema} from "../../../../apis";

const CourseEntity = ({item, children, defaultItem}) => (
  <SelectEntityItem
    item={item}
    defaultItem={defaultItem}
    schema={courseSchema}>
    {(data) => children(data)}
  </SelectEntityItem>
)

export const CourseEntities = ({items, children, defaultItem}) => (
  <SelectEntityItem
    item={items}
    defaultItem={defaultItem}
    schema={[courseSchema]}>
    {(data = []) => children(_.filter(data, notEmpty))}
  </SelectEntityItem>
)

export default CourseEntity
